import { HeadlessFormProvider } from '@delmonicos/shared-design-system-react/src/contexts/headless-form.provider';
import { SubmitHandlerWithDirtyFields } from '@delmonicos/shared-design-system-react/src/contexts/multi-step-form.provider';
import { GetTokensPaginatedModel } from '@delmonicos/shared-sdk/libs/cpms/src/apps/charge-point-operators-gateway/src/tokens/models/inputs/get-tokens-paginated.model';
import { SubmitErrorHandler } from 'react-hook-form';

import { useFilterSearchTokenListContext } from '../../token.context';
import { TokenListFilterSearchFormStep1Controller } from '../token-list-filter-search-form-step-1/token-list-filter-search-form-step-1.controller';

export interface TokenListFilterSearchFormControllerProps {
  onError: SubmitErrorHandler<GetTokensPaginatedModel>;
  onSubmit: SubmitHandlerWithDirtyFields<GetTokensPaginatedModel>;
  onCancel: () => void;
}

export const TokenListFilterSearchFormController = (
  props: TokenListFilterSearchFormControllerProps,
): React.JSX.Element => {
  const { onError, onSubmit, onCancel } = props;
  const data = useFilterSearchTokenListContext();

  return (
    <HeadlessFormProvider<GetTokensPaginatedModel>
      useFormProps={{
        mode: 'all',
        defaultValues: data,
      }}
      submitErrorHandler={onError}
      submitHandler={onSubmit}
      onCancel={onCancel}
      item={{
        fields: ['textToSearch'],
        component: <TokenListFilterSearchFormStep1Controller />,
      }}
    />
  );
};
